import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import formStyles from 'utils/formStyles';
import { IconButton } from '@material-ui/core';
import { AddIcon } from 'evergreen-ui';

const btnStyle = {
  margin: '0 8px 0 2px',
  padding: 0,
};

const useStyles = makeStyles((theme) => ({
  ...formStyles,
}));

function Autocomplete2(props) {
  const classes = useStyles();
  const {
    disabled,
    error,
    value,
    options,
    className,
    label,
    onChange,
    onAdd,
    compact,
    getOptionSelected = (option, value) => option.Code === value.Code,
    getOptionLabel = (option) => option.Code ? option.Code : '',
    renderOption = (option) => (
      <span>
        <strong>{option.Code}</strong>
        {!!option.Description && <> - {option.Description}</>}
      </span>
    )
  } = props;

  const helperText = compact ? undefined : typeof error === 'string' ? error : ' '

  return (
    <Autocomplete
      options={options || []}
      classes={{
        option: classes.option,
        root: classes.autocomplete,
      }}
      className={className}
      disabled={disabled}
      autoHighlight
      getOptionLabel={getOptionLabel}
      getOptionSelected={getOptionSelected}
      renderOption={renderOption}
      onChange={onChange}
      value={value}
      renderInput={(params) => (
        <TextField
          {...params}
          error={!!error}
          helperText={helperText}
          label={label}
          variant="outlined"
          size="small"
          InputProps={{
            ...params.InputProps,
            autoComplete: 'new-password',
            startAdornment: Boolean(onAdd) ? (
              <IconButton style={btnStyle} onClick={onAdd}>
                <AddIcon fontSize="small" />
              </IconButton>
            ) : null,
          }}
          inputProps={{
            ...params.inputProps,
            autoComplete: 'new-password',
          }}
        />
      )}
    />
  );
}

export default Autocomplete2;